<div class="new-item-modal">
  <button mat-button color="accent" (click)="addNewItem()">Add new</button>
</div>
